export default __webpack_public_path__ + "static/media/cpv_92_culture-sport-recreation.d049a338.svg";